<div class="card-box">
  <kendo-tabstrip #tabstrip class="nav-bordered">
    <kendo-tabstrip-tab [title]="'Pagamentos pela Loja'" [selected]="true">
      <ng-template kendoTabContent>
        <h5>Ative ou desative as opções de pagamento aceitas pela loja.</h5>

        <kendo-tabstrip class="nav-bordered mt-3">
          <kendo-tabstrip-tab [title]="'Credito'" [selected]="true">
            <ng-template kendoTabContent>
              <app-grid-formas-de-pagamento [empresa]="empresa" [formasDePagamento]="obtenhaFormasPagamentoMetodo('CREDITO')" [loading]="loading">

              </app-grid-formas-de-pagamento>
            </ng-template>
          </kendo-tabstrip-tab>

          <kendo-tabstrip-tab [title]="'Débito'"  >
            <ng-template kendoTabContent>
              <app-grid-formas-de-pagamento  [empresa]="empresa" [formasDePagamento]="obtenhaFormasPagamentoMetodo('DEBITO')"  [loading]="loading">

              </app-grid-formas-de-pagamento>
            </ng-template>
          </kendo-tabstrip-tab>

          <kendo-tabstrip-tab [title]="'Dinheiro'"  >
            <ng-template kendoTabContent>
              <app-grid-formas-de-pagamento  [empresa]="empresa" [formasDePagamento]="obtenhaFormasPagamentoMetodo('DINHEIRO')"  [loading]="loading">

              </app-grid-formas-de-pagamento>
            </ng-template>
          </kendo-tabstrip-tab>


          <kendo-tabstrip-tab [title]="'Vales'"  >
            <ng-template kendoTabContent>
              <app-grid-formas-de-pagamento  [empresa]="empresa" [formasDePagamento]="obtenhaFormasPagamentoMetodo(null,'VALE_')"  [loading]="loading">

              </app-grid-formas-de-pagamento>
            </ng-template>
          </kendo-tabstrip-tab>

          <kendo-tabstrip-tab [title]="'Manual'"  >
            <ng-template kendoTabContent>
              <app-grid-formas-de-pagamento  [empresa]="empresa" [formasDePagamento]="obtenhaFormasPagamentoTipo('MANUAL')"  [loading]="loading">

              </app-grid-formas-de-pagamento>
            </ng-template>
          </kendo-tabstrip-tab>


          <kendo-tabstrip-tab [title]="'Ifood Loja'"  *ngIf="empresa?.integracoesIfood?.length">
            <ng-template kendoTabContent>
              <app-grid-formas-de-pagamento  [empresa]="empresa" [ocultarAtivar] = true
                                             [formasDePagamento]="obtenhaFormasPagamentoIfoodPdv()" [loading]="loading">

              </app-grid-formas-de-pagamento>
            </ng-template>
          </kendo-tabstrip-tab>


          <kendo-tabstrip-tab [title]="'Fidelidade'"   *ngIf="empresa.integracaoFidelidade">
            <ng-template kendoTabContent>
              <app-grid-formas-de-pagamento  [empresa]="empresa" [formasDePagamento]="obtenhaFormasPagamentoTipo('CASHBACK')"  [loading]="loading">

              </app-grid-formas-de-pagamento>
            </ng-template>
          </kendo-tabstrip-tab>

        </kendo-tabstrip>

      </ng-template>
    </kendo-tabstrip-tab>

    <kendo-tabstrip-tab [title]="nomeTabOnline"  >
      <ng-template kendoTabContent>
        <h5>Cadastre e ative as formas de pagamentos online loja vai aceitar</h5>

        <kendo-tabstrip class="nav-bordered mt-3">
          <kendo-tabstrip-tab [title]="'Meucardapio Online'" [selected]="true">
            <ng-template kendoTabContent>
              <div class="row">
                <div class="col" style="max-width: 320px">
                  <button class="btn btn-warning mb-3" (click)="novoOnline()">
                    <i class="fe-plus  1"></i>
                    Nova Forma de Pagamento Online
                  </button>
                </div>
                <div class="col">
                  <span #pagarmehub id="pagarme-hub" class="mb-2"></span>

                  <div class="form-group mb-3  " *ngIf="empresa.integracaoGatewayPagamento?.sandbox">
                    <span class="badge badge-danger">Sandbox - Teste</span>
                  </div>
                </div>
              </div>

              <app-grid-formas-de-pagamento  [empresa]="empresa" [online]="true"
                                             [formasDePagamento]="formasDePagamentoOnline" [loading]="loading">

              </app-grid-formas-de-pagamento>

            </ng-template>
          </kendo-tabstrip-tab>

          <kendo-tabstrip-tab [title]="'Ifood Online'"  *ngIf="empresa?.integracoesIfood?.length" >
            <ng-template kendoTabContent>
              <app-grid-formas-de-pagamento  [empresa]="empresa" [formasDePagamento]="obtenhaFormasPagamentoIfoodOnline()"  [ocultarBotoes]="true">

              </app-grid-formas-de-pagamento>
            </ng-template>
          </kendo-tabstrip-tab>

        </kendo-tabstrip>

      </ng-template>
    </kendo-tabstrip-tab>

  </kendo-tabstrip>


</div>
